import { Controller } from "@hotwired/stimulus"
import PinForm from "../components/PinForm.svelte";

export default class extends Controller {
  connect() {
    const target = this.element;
    new PinForm({
      target: target,
        props: {
          pin: JSON.parse(target.dataset.pin),
          tags: JSON.parse(target.dataset.tags),
          formUrl: target.dataset.formUrl,
          errors: JSON.parse(target.dataset.errors),
        }
    })

  }

  disconnect() {
    this.element.innerHTML = "";
  }
}
